// extracted by mini-css-extract-plugin
module.exports = {"page":"CertifyCompany_page_7FBXx","action_btn":"CertifyCompany_action_btn_l0gBA","goBack":"CertifyCompany_goBack_pXa0n"};